import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'border-input relative flex h-13 w-13 items-center justify-center bg-white text-lg leading-[1.4] transition-all max-lg:h-9 max-lg:w-9 max-lg:text-sm',
    fakeCaretWrapper:
      'pointer-events-none absolute inset-0 flex items-center justify-center',
    fakeCaret: 'animate-caret-blink h-4 w-px bg-black duration-1000'
  },
  variants: {
    isActive: {
      true: {
        base: 'ring-ring ring-offset-background z-10 ring-2'
      }
    }
  },
  defaultVariants: {}
});
